export default "__VITE_ASSET__B51cdd9c__"